const TYPE_BUSINESS = "business";
const TYPE_POOL = "pool";
const TYPE_SPACE = "space";
const TYPE_TRANSPORTER = "transporter";
const TYPE_POS = "pos";
const TYPE_HO_HS = "ho-hs";
const TYPE_HO_SALES = "ho-sales";

const types = [
  {
    type: TYPE_BUSINESS,
    title: "Mitra Bisnis"
  },
  {
    type: TYPE_POOL,
    title: "Mitra Pool Warehouse"
  },
  {
    type: TYPE_SPACE,
    title: "Mitra Space"
  },
  {
    type: TYPE_TRANSPORTER,
    title: "Mitra Transporter"
  },
  {
    type: TYPE_POS,
    title: "Mitra Pos"
  },
  {
    type: TYPE_HO_HS,
    title: "Mitra HO HS"
  },
  {
    type: TYPE_HO_SALES,
    title: "Mitra HO Sales"
  },
];

export { types, TYPE_BUSINESS, TYPE_POOL, TYPE_SPACE, TYPE_TRANSPORTER, TYPE_POS, TYPE_HO_HS, TYPE_HO_SALES };
